"use client"

import { create } from "zustand"

export interface WaitingConversation {
    threadId: string
    title: string | null
    question?: string | null
    isWorkingAtClose: boolean
    closedAt: number
}

interface WaitingConversationState {
    waiting: WaitingConversation | null
    setWaiting: (waiting: WaitingConversation | null) => void
    dismiss: () => void
}

export const useWaitingConversationStore = create<WaitingConversationState>()(
    set => ({
        waiting: null,
        setWaiting: waiting => set({ waiting }),
        dismiss: () => set({ waiting: null }),
    })
)
